import { AlertTriangle } from 'lucide-react'
import type { CsvIssue } from '../utils/csv'

/**
 * Pre-download integrity banner for a vendor CSV export. Errors here mean the
 * file would arrive at the vendor short or misaligned, so they gate the download.
 */
export function CsvIntegrityWarning({ issues }: { issues: CsvIssue[] }) {
  if (issues.length === 0) return null
  const hasError = issues.some(i => i.level === 'error')
  const tone = hasError
    ? 'bg-red-500/10 text-red-400 border-red-500/30'
    : 'bg-amber-500/10 text-amber-400 border-amber-500/30'

  return (
    <div className={`rounded border px-2 py-1.5 space-y-1 ${tone}`}>
      <div className="flex items-center gap-1 text-[10px] font-semibold">
        <AlertTriangle size={11} />
        {hasError ? 'Data integrity check failed' : 'Data integrity warning'}
      </div>
      <ul className="space-y-0.5">
        {issues.map((issue, i) => (
          <li key={i} className="text-[9px] leading-snug opacity-90">• {issue.message}</li>
        ))}
      </ul>
    </div>
  )
}
